import slugify from 'slugify';
import getClassifiedsSite from 'utils/getClassifiedsSite';
// import * as R from 'ramda';

const subdomainsToNoIndex = ['usedcars', 'car-leasing', 'production'];

const hostname =
  (typeof window !== 'undefined' &&
    window.location &&
    window.location.hostname) ||
  '';

const getSubdomain = host => {
  const parts = host.split('.');
  // Extract the first part as subdomain
  if (parts.length > 1) {
    return parts[0];
  }
  return '';
};

const shouldAddNoIndex = subdomainsToNoIndex.includes(getSubdomain(hostname));
const disableIndexingAndFollowLinks = 'noindex,nofollow';
const enableIndexingAndFollowLinks = 'index,follow';

const getRobots = rule =>
  shouldAddNoIndex ? disableIndexingAndFollowLinks : rule;

const home = _ => {
  const results = {
    'used-cars': {
      whatcar: {
        title: 'Used Cars for Sale | Browse and Buy on What Car?',
        description:
          'Looking for used cars? Find your ideal second hand used car from top dealers in your area on What Car? Classifieds.',
        url: '/used-cars',
        robots: getRobots(enableIndexingAndFollowLinks)
      },
      autocar: {
        title: 'Used Cars for Sale | Browse and Buy on Autocar',
        description:
          'Looking for a used car? Find your ideal second hand used car from approved used dealers in your area on Autocar Classifieds.',
        url: '/used-cars',
        robots: getRobots(enableIndexingAndFollowLinks)
      }
    },
    'car-leasing-deals': {
      whatcar: {
        title: 'Car Lease Deals | What Car? Leasing',
        description:
          'Discover the best car lease deals at What Car? Leasing. Find affordable leasing options on a wide range of vehicles and drive your car today.',
        url: '/car-leasing-deals',
        robots: getRobots(enableIndexingAndFollowLinks)
      },
      autocar: {
        title: 'Car Lease Deals | Autocar Leasing',
        description:
          'Discover the best car lease deals at Autocar Leasing. Find affordable leasing options on a wide range of vehicles and drive your car today.',
        url: '/car-leasing-deals',
        robots: getRobots(enableIndexingAndFollowLinks)
      }
    },
    'new-cars-in-stock': {
      whatcar: {
        title: 'Find your perfect in stock cars for sale.',
        description:
          "Find your perfect in-stock car with What Car? Explore the UK's largest selection of discounted new cars, backed by over 50 years of car-buying expertise. Start your search now!",
        url: '/new-cars-in-stock',
        robots: getRobots(enableIndexingAndFollowLinks)
      },
      autocar: {
        title: 'New cars in stock | Browse and buy on Autocar',
        description:
          "Find your perfect in-stock car with Autocar Explore the UK's largest selection of discounted new cars, backed by over 50 years of car-buying expertise. Start your search now!",
        url: '/new-cars-in-stock',
        robots: getRobots(enableIndexingAndFollowLinks)
      }
    }
  };

  const classifiedsSite = getClassifiedsSite();
  return results[_][classifiedsSite];
};

// const isFiltered = filter => {
//   const props = ['make', 'model', 'nearlynew', 'used', 'isPostCodeValid'];
//   return R.keys(filter).filter(_ => !R.contains(_, props)).length > 0;
// };

const resultsCar = (props, count, filter, pagination, thisPageData) => {
  pagination = pagination || {};
  filter = filter || {};

  let make = props.make;

  if (!make && typeof window !== 'undefined') {
    const pathname = window.location.pathname;
    const parts = pathname.split('/');
    make = parts[2] || '';
  }
  const makeText = make || '';

  const model = props.model ? slugify(props.model) : '';
  const modelText = props.model ? ' ' + props.model : '';
  const title = props.make ? `${props.make}${modelText} cars` : 'Cars';
  const formatedTitle = props.make ? `${props.make}${modelText}` : 'car';
  const titleLeasing = props.make ? `${props.make}${modelText}` : '';
  const noMakeOrModelTitle = !make && !model ? 'Cars' : '';
  const descriptionTitle = props.make ? `${props.make}${modelText} car` : 'car';
  const modelUrl = model ? `/${model}` : '';
  const url = make ? `${make}${modelUrl}` : 'all';

  const results = {
    'used-cars': {
      whatcar: {
        title: `${thisPageData &&
          thisPageData.shortName} ${title} for sale on What Car?`,
        pageTitle: `${thisPageData &&
          thisPageData.shortName} ${title} for sale on What Car?`,
        description: `Looking for used cars? Find your ideal second hand used ${descriptionTitle} from top dealers in your area on What Car? Classifieds.`,
        url: `/${thisPageData.name}/${url.toLowerCase()}`,
        robots: getRobots(enableIndexingAndFollowLinks),
        blurb: `What Car? Classifieds has ${count} approved ${thisPageData.type} ${title} available for sale from top ${makeText} dealers. Browse our classifieds now - the easiest and most powerful ${thisPageData.type} car search tool around – and find the perfect approved used ${titleLeasing} near you.`,
        pagination: pagination
      },
      autocar: {
        title: `${thisPageData &&
          thisPageData.shortName} ${title} for sale on Autocar`,
        pageTitle: `${thisPageData &&
          thisPageData.shortName} ${title} for sale on Autocar`,
        description: `Looking for used cars? Find your ideal second hand used ${descriptionTitle} from top dealers in your area on Autocar Classifieds.`,
        url: `/used-cars/${url.toLowerCase()}`,
        robots: getRobots(enableIndexingAndFollowLinks),
        blurb: `Autocar Classifieds has ${count} approved ${thisPageData.type} ${title} available for sale from top ${makeText} dealers. Browse our classifieds now - the easiest and most powerful ${thisPageData.type} car search tool around – and find the perfect approved used ${titleLeasing} near you.`,
        pagination: pagination
      }
    },
    'car-leasing-deals': {
      whatcar: {
        title: `${titleLeasing &&
          titleLeasing} Lease Deals | What Car? Leasing`,
        pageTitle: `${make} ${model} ${noMakeOrModelTitle} lease deals`,
        description: `Discover unbeatable ${descriptionTitle} lease deals on What Car? Browse 65 approved in-stock cars from trusted dealers and find your perfect ${make} lease today!`,
        url: `/${thisPageData.name}/${url.toLowerCase()}`,
        robots: getRobots(enableIndexingAndFollowLinks),
        blurb: `What Car? Leasing has ${count} new ${title} in stock and available to lease from ${makeText} approved dealers. Browse the deals now and find the perfect ${formatedTitle} near you.`,
        pagination: pagination
      },
      autocar: {
        title: `Used ${title} for sale on Autocar`,
        pageTitle: `${make} ${model} lease deals`,
        description: `Discover unbeatable ${descriptionTitle} lease deals on Autocar Browse 65 approved in-stock cars from trusted dealers and find your perfect ${make} lease today!`,
        url: `/${thisPageData.name}/${url.toLowerCase()}`,
        robots: getRobots(enableIndexingAndFollowLinks),
        blurb: `Autocar Leasing has ${count} new ${title} in stock and available to lease from ${makeText} approved dealers. Browse the deals now and find the perfect ${formatedTitle} near you.`,
        pagination: pagination
      }
    },
    'new-cars-in-stock': {
      whatcar: {
        title: 'Find your perfect in stock cars for sale',
        pageTitle: `${title && title} available for sale now on What Car?`,
        description:
          "Find your perfect in-stock car with What Car? Explore the UK's largest selection of discounted new cars, backed by over 50 years of car-buying expertise. Start your search now!",
        url: `/${thisPageData.name}/${url.toLowerCase()}`,
        robots: getRobots(enableIndexingAndFollowLinks),
        blurb: `We have ${count} new ${title} available from offical ${makeText} dealers. Browse now, and find the perfect new ${formatedTitle} near you.`,
        pagination: pagination
      },
      autocar: {
        title: 'Find your perfect in stock cars for sale',
        pageTitle: `${title && title} available for sale now on Autocar`,
        description:
          "Find your perfect in-stock car with Autocar Explore the UK's largest selection of discounted new cars, backed by over 50 years of car-buying expertise. Start your search now!",
        url: `/${thisPageData.name}/${url.toLowerCase()}`,
        robots: getRobots(enableIndexingAndFollowLinks),
        blurb: `We have ${count} new ${title} available from offical ${makeText} dealers. Browse now, and find the perfect new ${formatedTitle} near you.`,
        pagination: pagination
      }
    }
  };

  const classifiedsSite = getClassifiedsSite();
  return results[thisPageData.name][classifiedsSite];
};

const resultsDealer = (dealer, id, pagination, thisPageData) => {
  pagination = pagination || {};

  const results = {
    'used-cars': {
      whatcar: {
        title: `${dealer} used cars for sale on What Car?`,
        description: `Find and buy your perfect used car from ${dealer} on What Car? Classifieds, the easiest and most powerful used car search around.`,
        url: `/used-cars/dealer/${id}`,
        robots: getRobots(enableIndexingAndFollowLinks),
        blurb: `Find and buy your perfect used car from ${dealer} on What Car? Classifieds, the easiest and most powerful used car search around.`,
        pagination: pagination
      },
      autocar: {
        title: `${dealer} used cars for sale on Autocar`,
        description: `Find and buy your perfect used car from ${dealer} on Autocar Classifieds, the easiest and most powerful used car search around.`,
        url: `/used-cars/dealer/${id}`,
        robots: getRobots(enableIndexingAndFollowLinks),
        blurb: `Find and buy your perfect used car from ${dealer} on Autocar Classifieds, the easiest and most powerful used car search around.`,
        pagination: pagination
      }
    },
    'car-leasing-deals': {
      whatcar: {
        title: `${dealer} used cars for sale on What Car?`,
        description: `Find and buy your perfect used car from ${dealer} on What Car? Classifieds, the easiest and most powerful used car search around.`,
        url: `/used-cars/dealer/${id}`,
        robots: getRobots(enableIndexingAndFollowLinks),
        blurb: `Find and buy your perfect used car from ${dealer} on What Car? Classifieds, the easiest and most powerful used car search around.`,
        pagination: pagination
      },
      autocar: {
        title: `${dealer} used cars for sale on Autocar`,
        description: `Find and buy your perfect used car from ${dealer} on Autocar Classifieds, the easiest and most powerful used car search around.`,
        url: `/used-cars/dealer/${id}`,
        robots: getRobots(enableIndexingAndFollowLinks),
        blurb: `Find and buy your perfect used car from ${dealer} on Autocar Classifieds, the easiest and most powerful used car search around.`,
        pagination: pagination
      }
    },
    'new-cars-in-stock': {
      whatcar: {
        title: `${dealer} used cars for sale on What Car?`,
        description: `Find and buy your perfect used car from ${dealer} on What Car? Classifieds, the easiest and most powerful used car search around.`,
        url: `/used-cars/dealer/${id}`,
        robots: getRobots(enableIndexingAndFollowLinks),
        blurb: `Find and buy your perfect used car from ${dealer} on What Car? Classifieds, the easiest and most powerful used car search around.`,
        pagination: pagination
      },
      autocar: {
        title: `${dealer} used cars for sale on Autocar`,
        description: `Find and buy your perfect used car from ${dealer} on Autocar Classifieds, the easiest and most powerful used car search around.`,
        url: `/used-cars/dealer/${id}`,
        robots: getRobots(enableIndexingAndFollowLinks),
        blurb: `Find and buy your perfect used car from ${dealer} on Autocar Classifieds, the easiest and most powerful used car search around.`,
        pagination: pagination
      }
    }
  };

  const classifiedsSite = getClassifiedsSite();
  return results[thisPageData.name][classifiedsSite];
};

const resultsBodyStyle = (category, count, pagination, thisPageData) => {
  pagination = pagination || {};

  const results = {
    'used-cars': {
      whatcar: {
        title: `Used ${category} cars for sale on What Car?`,
        description: `Find and buy your perfect used ${category} with What Car? Classifieds, the easiest and most powerful used car search around.`,
        url: `/used-cars/${category}`,
        robots: getRobots(enableIndexingAndFollowLinks),
        blurb: `What Car? Classifieds have ${count} approved used ${category} available for sale from approved dealers. Browse our classifieds now, the easiest and most powerful used car search around and find the perfect approved used ${category} near you.`,
        pagination: pagination
      },
      autocar: {
        title: `Used ${category} cars for sale on Autocar`,
        description: `Search for your perfect used ${category} on Autocar Classifieds. Every car comes with a warranty & is guaranteed to be less than eight years & 100,000 miles old.`,
        url: `/used-cars/${category}`,
        robots: getRobots(enableIndexingAndFollowLinks),
        blurb: `Autocar Classified have ${count} approved used ${category} available for sale from approved dealers. Browse our classifieds now, the easiest and most powerful used car search around and find the perfect approved used ${category} near you.`,
        pagination: pagination
      }
    },
    'car-leasing-deals': {
      whatcar: {
        title: `Used ${category} cars for sale on What Car?`,
        description: `Find and buy your perfect used ${category} with What Car? Classifieds, the easiest and most powerful used car search around.`,
        url: `car-leasing-deals/${category}`,
        robots: getRobots(enableIndexingAndFollowLinks),
        blurb: `What Car? Classifieds have ${count} approved used ${category} available for sale from approved dealers. Browse our classifieds now, the easiest and most powerful used car search around and find the perfect approved used ${category} near you.`,
        pagination: pagination
      },
      autocar: {
        title: `Used ${category} cars for sale on Autocar`,
        description: `Search for your perfect used ${category} on Autocar Classifieds. Every car comes with a warranty & is guaranteed to be less than eight years & 100,000 miles old.`,
        url: `car-leasing-deals/${category}`,
        robots: getRobots(enableIndexingAndFollowLinks),
        blurb: `Autocar Classified have ${count} approved used ${category} available for sale from approved dealers. Browse our classifieds now, the easiest and most powerful used car search around and find the perfect approved used ${category} near you.`,
        pagination: pagination
      }
    },
    'new-cars-in-stock': {
      whatcar: {
        title: `Used ${category} cars for sale on What Car?`,
        description: `Find and buy your perfect used ${category} with What Car? Classifieds, the easiest and most powerful used car search around.`,
        url: `new-cars-in-stock/${category}`,
        robots: getRobots(enableIndexingAndFollowLinks),
        blurb: `What Car? Classifieds have ${count} approved used ${category} available for sale from approved dealers. Browse our classifieds now, the easiest and most powerful used car search around and find the perfect approved used ${category} near you.`,
        pagination: pagination
      },
      autocar: {
        title: `Used ${category} cars for sale on Autocar`,
        description: `Search for your perfect used ${category} on Autocar Classifieds. Every car comes with a warranty & is guaranteed to be less than eight years & 100,000 miles old.`,
        url: `new-cars-in-stock/${category}`,
        robots: getRobots(enableIndexingAndFollowLinks),
        blurb: `Autocar Classified have ${count} approved used ${category} available for sale from approved dealers. Browse our classifieds now, the easiest and most powerful used car search around and find the perfect approved used ${category} near you.`,
        pagination: pagination
      }
    }
  };

  const classifiedsSite = getClassifiedsSite();
  return results[thisPageData.name][classifiedsSite];
};

const listing = (title, county, url, image, thisPageData) => {
  const results = {
    'used-cars': {
      whatcar: {
        title: title
          ? `Used ${title} car for sale on What Car?`
          : `Used car for sale on What Car?`,
        description: `Used ${title} for sale in ${county} with What Car? Classifieds, the easiest and most powerful used car search around.`,
        url: url,
        robots: getRobots(enableIndexingAndFollowLinks),
        image: image
      },
      autocar: {
        title: title
          ? `Used ${title} car for sale on Autocar`
          : `Used car for sale on Autocar`,
        description: `Used ${title} for sale in ${county} with Autocar Classifieds. Every car comes with a warranty & is guaranteed to be less than eight years & 100,000 miles old.`,
        url: url,
        robots: getRobots(enableIndexingAndFollowLinks),
        image: image
      }
    },
    'car-leasing-deals': {
      whatcar: {
        title: title
          ? `Used ${title} car for sale on What Car?`
          : `Used car for sale on What Car?`,
        description: `Used ${title} for sale in ${county} with What Car? Classifieds, the easiest and most powerful used car search around.`,
        url: url,
        robots: getRobots(enableIndexingAndFollowLinks),
        image: image
      },
      autocar: {
        title: title
          ? `Used ${title} car for sale on Autocar`
          : `Used car for sale on Autocar`,
        description: `Used ${title} for sale in ${county} with Autocar Classifieds. Every car comes with a warranty & is guaranteed to be less than eight years & 100,000 miles old.`,
        url: url,
        robots: getRobots(enableIndexingAndFollowLinks),
        image: image
      }
    },
    'new-cars-in-stock': {
      whatcar: {
        title: title
          ? `Used ${title} car for sale on What Car?`
          : `Used car for sale on What Car?`,
        description: `Used ${title} for sale in ${county} with What Car? Classifieds, the easiest and most powerful used car search around.`,
        url: url,
        robots: getRobots(enableIndexingAndFollowLinks),
        image: image
      },
      autocar: {
        title: title
          ? `Used ${title} car for sale on Autocar`
          : `Used car for sale on Autocar`,
        description: `Used ${title} for sale in ${county} with Autocar Classifieds. Every car comes with a warranty & is guaranteed to be less than eight years & 100,000 miles old.`,
        url: url,
        robots: getRobots(enableIndexingAndFollowLinks),
        image: image
      }
    }
  };

  const classifiedsSite = getClassifiedsSite();
  return results[thisPageData.name][classifiedsSite];
};

module.exports = { home, resultsCar, resultsDealer, resultsBodyStyle, listing };



// WEBPACK FOOTER //
// ./src/App/variables/seo.js